module.exports = __webpack_public_path__ + "img/diners-club.1806fc50.png";